// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"k20PKh","container":"cGcrUt"};